import { EnvelopeIcon, GlobeAltIcon, PhoneIcon } from '@heroicons/react/24/outline';
import React from 'react';
import { SharedBranding } from '../../../services';

// #region ShareBrandFooterProps
export interface ShareBrandFooterProps {
    branding: SharedBranding;
}

// #region prettyWebsite
const prettyWebsite = (url: string): string => url.replace('https://', '').replace('http://', '').replace(/\/$/, '');

// #region ShareBrandFooter
// Designer contact card, with a small, subtle Wallmates credit beneath it.
export const ShareBrandFooter: React.FunctionComponent<ShareBrandFooterProps> = (props: ShareBrandFooterProps): JSX.Element => {
    const { branding } = props;

    const hasContact = !!(branding.contact_email || branding.contact_phone || branding.contact_website);
    const linkClass = 'inline-flex min-h-[36px] items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-sm text-share-muted transition-colors hover:bg-share-primary-soft hover:text-share-primary';

    return (
        <footer className="mt-8">
            {(branding.contact_name || hasContact) && (
                <div className="rounded-3xl border border-share-border bg-share-raised px-5 py-6 text-center shadow-sm sm:px-8">
                    {branding.contact_name && (
                        <>
                            <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-share-muted">
                                Questions about your picks?
                            </div>
                            <div className="mt-1.5 text-lg font-semibold text-share-text">{branding.contact_name}</div>
                        </>
                    )}
                    {hasContact && (
                        <div className="mt-3 flex flex-wrap items-center justify-center gap-x-2 gap-y-1">
                            {branding.contact_email && (
                                <a className={linkClass} href={`mailto:${branding.contact_email}`}>
                                    <EnvelopeIcon className="h-4 w-4" />
                                    {branding.contact_email}
                                </a>
                            )}
                            {branding.contact_phone && (
                                <a className={linkClass} href={`tel:${branding.contact_phone}`}>
                                    <PhoneIcon className="h-4 w-4" />
                                    {branding.contact_phone}
                                </a>
                            )}
                            {branding.contact_website && (
                                <a className={linkClass} href={branding.contact_website} target="_blank" rel="noreferrer">
                                    <GlobeAltIcon className="h-4 w-4" />
                                    {prettyWebsite(branding.contact_website)}
                                </a>
                            )}
                        </div>
                    )}
                </div>
            )}

            <div className="pb-4 pt-5 text-center text-[11px] tracking-wide text-share-muted opacity-70">
                Powered by Wallmates
            </div>
        </footer>
    );
};
